<template>
    <div class="ui-notification"
         :class="[notification.type, {clickable: notification.closeOnClick, 'custom-template': !!notification.component}]"
         @click="onClick">
        <h3 v-if="notification.title" v-html="notification.title"></h3>
        <component v-if="notification.component"
                   :is="notification.component"
                   v-bind="notification.props"
                   @close="close"></component>
        <div v-else class="message" role="status" v-html="notification.message"></div>
    </div>
</template>

<script>
    export default {
        name: "NotificationToast",
        props: {
            notification: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                timeout: undefined
            };
        },
        mounted() {
            if (typeof this.notification.delay === 'number') {
                this.timeout = setTimeout(this.close, this.notification.delay);
            }
        },
        beforeUnmount() {
            clearTimeout(this.timeout);
        },
        methods: {
            close() {
                this.$emit('close');
            },
            onClick(e) {
                // let links inside custom templates work instead of just closing the notification
                if (this.notification.closeOnClick && !e.target.closest('a')) {
                    this.close();
                }
            }
        }
    };
</script>
